import queryString from 'query-string'
import { sortAssessorParticipants } from 'redux/selectors/participants'
import routeParams from '../../../../helpers/decorators/routeParams'

const LOAD_PARTICIPANTS = 'fo/assessor/LOAD_PARTICIPANTS'
const LOAD_PARTICIPANTS_SUCCESS = `${LOAD_PARTICIPANTS}_SUCCESS`
const LOAD_PARTICIPANTS_FAIL = `${LOAD_PARTICIPANTS}_FAIL`

const SET_FILTER = 'dofe-bo/assessor/SET_FILTER'

const initialState = {
  list: [],
  sortedParticipants: [],
  isLoading: false,
  isLoaded: false,
  filter: ''
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_PARTICIPANTS:
      return {
        ...state,
        isLoading: true,
        isLoaded: false
      }
    case LOAD_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        list: action.result,
        sortedParticipants: sortAssessorParticipants(
          action.result,
          action.options
        ),
        isLoading: false,
        isLoaded: true
      }
    case LOAD_PARTICIPANTS_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    default:
      return state
  }
}

export const loadAssessorParticipants = (params = {}, options) => ({
  types: [LOAD_PARTICIPANTS, LOAD_PARTICIPANTS_SUCCESS, LOAD_PARTICIPANTS_FAIL],
  promise: client =>
    client.get(
      'api/awards?' +
        queryString.stringify({
          sort: '-id',
          with:
            'ASSESSOR_ACTIVITIES,PARTICIPANT_PERSON,ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,RESIDENTIAL_PROJECT,ACTIVITIES,ACTIVITIES_WITH_PROGRESS,LEADER'
        }) + routeParams(params, '')
    ),
  options
})

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}
